// extracted by css-extract-rspack-plugin
export default {"ButtonLink":"p8cDj"};